import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../../utility/fetch";
import InputField from "../UI/InputField";
import EdsgLogo from "../../assets/images/ConnectHealthPro.png";

import greenz from "../../assets/images/favico.png";
import icon from "../../assets/images/favico.png";
import Footer from "../layouts/Footer";
import { get } from "../../utility/fetchClinic";
import axios from "axios";

const Home = (props) => {
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const makePostRequest = async (urltoken) => {
    // if (password === "" || email === "") {
    //   toast("Please enter email and password");
    //   return;
    // }
    // let baseurl = "https://edogoverp.com";

    // if (urltoken !== "") {
    //   setLoading(true);

    //   const authurl = "/pharmacyapi/api/Auth/Auth/";

    //   axios
    //     .post(`${baseurl}${authurl}?AuthToken=${urltoken}`, {
    //       headers: {
    //         "Access-Control-Allow-Credentials": true,
    //         crossorigin: true,
    //         "Access-Control-Allow-Methods": "POST",
    //         "Access-Control-Allow-Origin": "*",
    //       },
    //     })
    //     .then((response) => {
    //       const user_auth = response?.data;

    //       console.log(response);

    //       // getProfiles(user_auth?.clinicId);
    //       // sessionStorage.setItem("token", user_auth?.token);
    //       // sessionStorage.setItem("clinicId", user_auth?.clinicId);
    //       // sessionStorage.setItem("userId", user_auth?.userId);
    //       // localStorage.setItem("nurseRole", user_auth?.role);
    //       // localStorage.setItem("USER_INFO", JSON.stringify(user_auth));
    //       // sessionStorage.setItem("isAdmin", user_auth?.isAdmin);
    //       // sessionStorage.setItem("homeLink", user_auth?.homeLink);
    //       // // sessionStorage.setItem("_APIBaseURL", parsed.base);
    //       // sessionStorage.setItem("isAdmin", user_auth?.isAdmin);
    //       // sessionStorage.setItem(
    //       //   "name",
    //       //   `${user_auth?.firstName} ${user_auth?.lastName}`
    //       // );

    //       // const loginTime = new Date().getTime();
    //       // localStorage.setItem("LOGIN_TIME", loginTime);

    //       // Cookies.set(`${ModuleName}_AppToken`, user_auth?.token, {
    //       //   expires: 0.0416665,
    //       // });
    //       // Cookies.set("homeLink", user_auth?.homeLink);
    //       // Cookies.set(`${ModuleName}_AccessToken`, parsed?.emp);
    //       // Cookies.set("_APIBaseURL", parsed?.base);
    //       // Cookies.set("tokenExist", true, { expires: 0.0416665 });

    //       if (user_auth) {
    //         setLoading(false);
    //         // navigate("/facility"); // Redirect to dashboard
    //       } else {
    //         // setLoading(false);
    //         // store?.addNotification({
    //         //   title: "Error!",
    //         //   message: user_auth?.message,
    //         //   type: "danger",
    //         //   insert: "bottom",
    //         //   container: "bottom-left",
    //         //   animationIn: ["animate__animated", "animate__fadeIn"],
    //         //   animationOut: ["animate__animated", "animate__fadeOut"],
    //         //   dismiss: {
    //         //     duration: 5000,
    //         //     onScreen: true,
    //         //   },
    //         // });
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       // setLoading(false);
    //       // Cookies.set("_AppToken", null);
    //       // Cookies.set("tokenExist", false);
    //       // Cookies.set("_FullName", null);
    //       // Cookies.set("_Role", null);
    //       // Cookies.set("_Email", null);

    //       // store?.addNotification({
    //       //   title: "Error!",
    //       //   message: "You Do Not Have Access To this Application!",
    //       //   type: "danger",
    //       //   insert: "bottom",
    //       //   container: "bottom-left",
    //       //   animationIn: ["animate__animated", "animate__fadeIn"],
    //       //   animationOut: ["animate__animated", "animate__fadeOut"],
    //       //   dismiss: {
    //       //     duration: 5000,
    //       //     onScreen: true,
    //       //   },
    //       // });
    //     });
    // }
    setLoading(true);
    const payload = {
      email: email,
      password: password,
    };
    try {
      const data = await post(`/Auth/auth?AuthToken=${urltoken}`);
      console.log(data);
      // getProfiles(data?.clinicId);
      if (data?.role.includes("Doctor")) {
        sessionStorage.setItem("clinicId", data?.clinicId);
        localStorage.setItem("homeLink", data?.homeLink);
        sessionStorage.setItem("token", "Bearer " + data.jwt.token);
        sessionStorage.setItem("token-expiry-date", data.jwt.expirationDate);
        localStorage.setItem("name", data.firstName + " " + data.lastName);
        localStorage.setItem("role", data.role[0].replace(/[^\w\s]/gi, ""));
        localStorage.setItem("USER_INFO", JSON.stringify(data));

        navigate("/doctor/dashboard");
      } else {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/home`;
        throw { e: "Invalid Role" };
      }
    } catch (error) {
      console.log(error);
      localStorage.removeItem("USER_INFO");
      toast.error("Invalid login credentials");
    }
    setLoading(false);
  };

  const getProfiles = async (clinicId) => {
    const response = await get(`/clinic/${clinicId}`);
    localStorage.setItem("COMPANY_INFO", JSON.stringify(response));
    // localStorage.setItem("nurseRole", user_auth?.role);
    console.log(response);

    // setFormData({ ...formData, ...response });
    //   setTotalPaginationLength(response.totalPages * 10)
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const spinStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    animation: "spin 2s linear infinite", // Apply spinning animation
    borderRadius: "50%", // Circular shape
  };

  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }`;

  let urltoken = "";
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // Get the value of the 'username' parameter
    urltoken = params.get("emp");
    console.log(urltoken);
    // isadvance = params.get("isadvance");
    // fromdashboard = params.get("fromdashboard");
    // iscompliance = params.get("iscompliance");
    // isRequisition = params.get("isRequisition");
    // isVariation = params.get("isVariation");
    // requestid = params.get("requestid");

    // console.log(urltoken);
    urltoken
      ? makePostRequest(urltoken)
      : (window.location.href = `${process.env.REACT_APP_BASE_URL}/home`);
    // const query = qs.parse(location.search);
    // // encodeToken({ api: query.base }, 'api');
    // handleAuthentication(query.emp);
    // console.log(isadvance);
  }, []);

  return (
    <div className="w-100">
      <div className="banner">
        <div
          className="login w-100"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <div className="flex flex-v-center w-100">
              <style>{keyframes}</style> {/* Inject the keyframes CSS */}
              <div style={spinStyle} className="">
                <div className="">
                  <img
                    style={{
                      display: "flex",

                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    src={icon}
                    alt=""
                    width={100}
                    height={100}
                    className=""
                  />
                </div>
                <div className="w-100">
                  <img className="w-100" src={greenz} alt="" height={26} />
                </div>
              </div>
            </div>

            {/* <form onSubmit={(e) => e.preventDefault()}>
              <div className=' m-t-40'>
                <label>Email</label>
                <InputField type="text" name={"email"} value={email} placeholder={"Email"} onChange={(e) => setEmail(e.target.value)} required={true} />
              </div>
              <div className='m-t-40'>
                <label>Password</label>
                <div className='password-input-container'>
                  <InputField type={showPassword ? "text" : "password"} name={"password"} value={password} placeholder={"password"} onChange={(e) => setPassword(e.target.value)} required={true} />
                  <button type="button" onClick={toggleShowPassword} className='password-toggle-btn pointer'>{showPassword ? "Hide" : "Show"}</button>
                </div>
              </div>
              <div className='m-t-40'>
                <button disabled={loading} onClick={makePostRequest} className='w-100 btn' type='submit'>Submit</button>
              </div>
            </form> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
